import React, { useEffect, useRef, useState } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";

import CMTFront from "../../assets/img/new/cmnd-front.png";
import CMTBack from "../../assets/img/new/cmnd-back.png";

import Spinner from "../../assets/img/loading.gif";
import { useHistory } from "react-router";
import { setDataAccount } from "../client/actions";
import { useDispatch } from "react-redux";

import { capitalizeTheFirstLetter, validateCMT9, _diff2Date } from "../../util";

import * as _ from "lodash";

const appUrl = `${process.env.REACT_APP_API_URL}`;

function PageUploadCard(props) {
  const history = useHistory();
  const dispatch = useDispatch();

  const _maxFileSize = 5;
  const [isLoading, setIsLoading] = useState(false);

  const refFileFront = useRef(null);
  const refFileBack = useRef(null);

  const { ocrResult, _handleToast, dataAccount } = props;

  useEffect(() => {
    if (!dataAccount) {
      history.push("/open-account/check-info");
      return;
    }

    let _data = Object.assign({}, dataAccount);
    _data.C_PARAM_PERSONAL = null;
    dispatch(setDataAccount(_data));
  }, []);

  function _handleClickFront() {
    if (refFileFront.current) refFileFront.current.click();
  }

  function _handleClickBack() {
    if (refFileBack.current) refFileBack.current.click();
  }

  function readFile(e) {
    const { name, files } = e.target;

    if (files && files[0]) {
      var filesize = (files[0].size / 1024 / 1024).toFixed(4);
      if (filesize > _maxFileSize) {
        _handleToast(
          "Quý khách vui lòng upload file không quá " + _maxFileSize + "MB",
          "warning"
        );
        if (name === "front_mask") {
          document.getElementById("image-preview-front").nodeValue = "";
        } else {
          document.getElementById("image-preview-back").nodeValue = "";
        }
        return;
      }

      let _node;

      if (name === "front_mask") {
        _node = document.getElementById("image-preview-front");
      } else {
        _node = document.getElementById("image-preview-back");
      }

      var reader = new FileReader();

      reader.onload = function (e) {
        // preview
        _node.setAttribute("src", e.target.result);
      };

      reader.readAsDataURL(files[0]); // convert to base64 string
    }
  }

  function validateStep2() {
    let isCheck = true;
    var file1 = document.getElementById("ekyc-field-front-mask");
    var file2 = document.getElementById("ekyc-field-back-mask");

    if (!file1.files || !file1.files[0]) {
      isCheck = false;
    }
    if (!file2.files || !file2.files[0]) {
      isCheck = false;
    }

    return isCheck;
  }

  function _handleUploadFile() {
    if (!validateStep2()) {
      _handleToast("Quý khách hãy chọn file upload", "warning");
      return;
    }
    setIsLoading(true);
    var file1 = document.getElementById("ekyc-field-front-mask");
    var file2 = document.getElementById("ekyc-field-back-mask");

    const formData = new FormData();
    formData.append("anhMatTruoc", file1.files[0]);
    formData.append("anhMatSau", file2.files[0]);

    // upload file
    const request = fetch(appUrl + "/uploadFile", {
      method: "POST",
      body: formData,
    });
    request
      .then((response) => response.json())
      .then((json) => {
        if (json.iRs > 0) {
          // create request
          const { data } = json;
          handleRequestOcr(data);
        } else {
          setIsLoading(false);
          _handleToast(json.sRs, "error");
          // ocrResult(null);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        _handleToast(
          "Có lỗi trong quá trình xử lý. Vui lòng thử lại!",
          "error"
        );
        // ocrResult(null);
        throw error;
      });
  }

  function handleRequestOcr(params) {
    const param = {
      sid: dataAccount?.S_ID,
      anhMatTruoc: params?.anhMatTruoc,
      anhMatSau: params?.anhMatSau,
    };

    const url = `${appUrl}/ocrFpt`;
    const request = fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json; charset=UTF-8",
      },
      body: JSON.stringify(param),
    });

    request
      .then((response) => response.json())
      .then((json) => {
        setIsLoading(false);
        if (json.iRs === 1) {
          // create request
          if (json.data.message) {
            _handleToast(json.data.message, "error");
          } else {
            const { data } = json;

            if (data?.loaiCmt === "cmt_9_ms" && data?.ngayCap) {
              // validate 15 năm với cmt 9 số
              if (!validateCMT9(data?.ngayCap)) {
                _handleToast("CMT quý khách hết hạn, hãy thử lại", "error");
                return;
              }
            }

            if (data?.ngayHetHan) {
              const _diff = _diff2Date(new Date(), data?.ngayHetHan);

              if (_diff > 0) {
                _handleToast(
                  "CMND/CCCD quý khách hết hạn, hãy thử lại",
                  "error"
                );
                return;
              }
            }

            const _params = {
              name: capitalizeTheFirstLetter(data?.hoVaTen),
              cardId: data?.soCmt || "",
              address: capitalizeTheFirstLetter(data?.noiTru),
              birthday: data?.namSinh || "",
              sex: data?.gioiTinh || "",
              expiry: data?.ngayHetHan || "",
              issue_date: data?.ngayCap || "",
              issue_by:
                data?.loaiCmt === "cccd_chip_ms" ||
                data?.loaiCmt === "cccd/cmt_12_ms"
                  ? "Cục CS QLHC về TTXH"
                  : capitalizeTheFirstLetter(data?.noiCap),
              loaiCmt: data?.loaiCmt || "",
              province: data?.chiTietNoiTru?.province || "",
              anhMatTruoc: params?.anhMatTruoc,
              anhMatSau: params?.anhMatSau,
            };

            ocrResult(_params);
          }
        } else {
          _handleToast(json.data?.message || json.sRs, "error");
          // ocrResult(null);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        _handleToast(
          "Có lỗi trong quá trình xử lý. Vui lòng thử lại!",
          "error"
        );
        // ocrResult(null);
        throw error;
      });
  }

  return (
    <>
      {isLoading && (
        <div className="loading">
          <img src={Spinner} alt="" />
        </div>
      )}
      <Container>
        <Row>
          <Col lg="10" className="offset-lg-1">
            <div className="content pt180">
              <h2>Tải ảnh CMND/CCCD</h2>
              <form
                className="yt-online-form-step mt-0 mb-5"
                id="OnlineForm-step-2"
                method="post"
                encType="multipart/form-data"
                noValidate="novalidate"
              >
                <div className="yt-alert-message alert alert-info" role="alert">
                  <span className="text-danger">*</span>Quý khách vui lòng cung
                  cấp hình chụp CMND/CCCD còn hiệu lực, không bị mờ, bóng hoặc
                  mất góc. Thông tin hiển thị đầy đủ và rõ ràng. Các định dạng
                  file được chấp nhận:{" "}
                  <span className="highlight-info">jpg, jpeg, png</span>. Kích
                  thước tệp tối đa:{" "}
                  <span className="highlight-info">{_maxFileSize}MB</span>.
                </div>
                <div className="yt-identify-card-wrap">
                  <Row className="mt-3">
                    <Col className="front-wrap text-center">
                      <div className="identify-card-item">
                        <h6 className="title">TẢI ẢNH CMND/CCCD MẶT TRƯỚC</h6>
                        <div className="yt-upload-wrap" data-type="front">
                          <div className="bg">
                            <img
                              src={CMTFront}
                              alt=""
                              onClick={_handleClickFront}
                            />
                            {/* <CMTFront onClick={_handleClickFront} /> */}
                          </div>
                          <div className="image-preview-wrap">
                            <img
                              id="image-preview-front"
                              className="image-popup-no-margins image-preview"
                              src=""
                              href=""
                              alt="Ảnh CMND/CCCD mặt trước"
                              title="Ảnh CMND/CCCD mặt trước"
                              onClick={_handleClickFront}
                            />
                          </div>

                          <input
                            ref={refFileFront}
                            name="front_mask"
                            id="ekyc-field-front-mask"
                            type="file"
                            accept="image/*"
                            className="valid"
                            aria-invalid="false"
                            onChange={(event) => {
                              readFile(event);
                            }}
                          />
                        </div>
                      </div>
                      <div className="actions">
                        <a
                          type="buton"
                          className="btn yt-btn style-2 upload-image-button"
                          onClick={_handleClickFront}
                        >
                          Tải lên
                        </a>
                      </div>
                    </Col>
                    <Col className="back-wrap text-center">
                      <div className="identify-card-item">
                        <h6 className="title">TẢI ẢNH CMND/CCCD MẶT SAU</h6>
                        <div className="yt-upload-wrap" data-type="back">
                          <div className="bg">
                            <img
                              src={CMTBack}
                              alt=""
                              onClick={_handleClickBack}
                            />
                            {/* <CMTBack onClick={_handleClickBack} /> */}
                          </div>
                          <div className="image-preview-wrap">
                            <img
                              id="image-preview-back"
                              className="image-popup-no-margins image-preview"
                              src=""
                              href=""
                              alt="Ảnh CMND/CCCD mặt sau"
                              title="Ảnh CMND/CCCD mặt sau"
                              onClick={_handleClickBack}
                            />
                          </div>
                          <input
                            ref={refFileBack}
                            name="back_mask"
                            id="ekyc-field-back-mask"
                            type="file"
                            accept="image/*"
                            className="valid"
                            aria-invalid="false"
                            onChange={(event) => {
                              readFile(event);
                            }}
                          />
                        </div>
                      </div>

                      <div className="actions">
                        <a
                          type="buton"
                          className="btn yt-btn style-2 upload-image-button"
                          onClick={_handleClickBack}
                        >
                          Tải lên
                        </a>
                      </div>
                    </Col>
                  </Row>
                  <Row className="justify-content-center mt-4 mb-5">
                    <Button
                      onClick={() => history.goBack()}
                      className="prev-page"
                    >
                      Quay lại
                    </Button>
                    <Button
                      className="btn-next"
                      type="button"
                      onClick={_handleUploadFile}
                    >
                      TIẾP TỤC
                    </Button>
                  </Row>
                </div>
              </form>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default PageUploadCard;
